import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const Moment = require('moment');
import DatePicker  from 'react-datepicker';
import { Row, Button } from 'react-bootstrap';
const find = require('lodash/find');
const isEqual = require('lodash/isEqual');

const Globals = require('../../../../app/globals');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const ServerRequest = require('../../actions/request');
import LoadingMainContent from '../loading/LoadingMainContent';
import LoadingSpinner from '../loading/LoadingSpinner';
import LoadingWithCancel from '../loading/LoadingWithCancel';
import SortableTableClassic from '../table/SortableTableClassic';
import ErrorBox from '../common/ErrorBox';

const STUDENTS_PER_PAGE = 100;

// redmine #5773
let persistentDateRange = {
    startDate: Moment().subtract(1, 'M').add(1, 'days').toDate(),
    endDate: new Date(),
};

const propTypes = {
    channelId: PropTypes.number.isRequired,
    orgName: PropTypes.string.isRequired,
    className: PropTypes.string,
    heading: PropTypes.string,
};

const defaultProps = {
    className: '',
    heading: 'Course Statistics',
};

class CourseStatsView extends React.Component {
    constructor(props) {
        super(props);
        this.pollTaskManager = new ServerRequest.PollTaskManager();
        this.state = {
            analyticsStoreState: AnalyticsStore.getState(),
            startDate: persistentDateRange.startDate,
            endDate: persistentDateRange.endDate,
            appliedStartDate: null,
            appliedEndDate: null,
            receivedStartDate: null,
            receivedEndDate: null,
            pending: false,
            pendingStudents: false,
            actionID: null,
            selectedCourseRowKey: "",
            selectedAssignmentRowKey: "",
            selectedStudentRowKey: "",
        };

        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onApplyDateRange = this.onApplyDateRange.bind(this);
        this.onCourseRowClick = this.onCourseRowClick.bind(this);
        this.onAssignmentRowClick = this.onAssignmentRowClick.bind(this);
        this.onStudentRowClick = this.onStudentRowClick.bind(this);
        this.getNewStudentCounts = this.getNewStudentCounts.bind(this);
        this.cancelPendingStudentCounts = this.cancelPendingStudentCounts.bind(this);
        this.requestStudentPage = this.requestStudentPage.bind(this);
        this.exportCsv = this.exportCsv.bind(this);
		this.clearOldCsvData = this.clearOldCsvData.bind(this);

        this.unsubscribes = [AnalyticsStore.listen(this.onStoreChange.bind(this, "analyticsStoreState"))];
    }

    componentDidMount() {
        // this.getNewStudentCounts();
    }

    componentWillUnmount() {
		this.clearOldCsvData(this.props.channelId, this.state.csv_data);
        this.unsubscribes.forEach(u => u());
        this.pollTaskManager.abandonTasks();
    }

    getNewStudentCounts() {
        const actionID = uuid.v4();
        const startDate = this.state.startDate;
        const endDate = this.state.endDate;
		this.clearOldCsvData(this.props.channelId, this.state.csv_data);
        if (this.state.actionID) {
            this.pollTaskManager.cancelAction(this.state.actionID);
        }
		
        this.setState(
            {
                actionID: actionID,
                appliedStartDate: startDate,
                appliedEndDate: endDate,
                studentPage: null,
                pending: true,
				csv_data: null,
            },
            () => {
                // AnalyticsActions.getChannelCourseStats(actionID, {id: this.props.channelId}); // gets all courses
                // get courses that had new students in the specified range
                AnalyticsActions.getChannelCourseNewStudentRange(actionID, {
                    id: this.props.channelId, 
                    startDate: Moment(startDate),
                    endDate: Moment(endDate)
                }, this.pollTaskManager); 
            }
        );
    }
    
    cancelPendingStudentCounts() {
        if (this.state.actionID) {
            this.pollTaskManager.cancelAction(this.state.actionID);
            this.setState({
                actionID: null, 
                pending: false,
                appliedStartDate: null,
                appliedEndDate: null,
            });
        }
    }


    getNewStudents() {
        const actionID = uuid.v4();
        const startDate = this.state.startDate;
        const endDate = this.state.endDate;
        let studentPage = this.state.studentPage;
        
        this.setState(
            {
                studentActionID: actionID,
                pendingStudents: true,
            },
            () => {
                // AnalyticsActions.getChannelCourseStats(actionID, {id: this.props.channelId}); // gets all courses
                // get courses that had new students in the specified range
                AnalyticsActions.getChannelCourseNewStudentRangePage(actionID, {
                    id: this.props.channelId, 
                    startDate: Moment(startDate),
                    endDate: Moment(endDate),
                    course_id: this.state.selectedCourseRowKey,
                    studentPage: studentPage
                }); 
            }
        );
    }

    
    requestStudentPage(page) {
        if (this.state.studentPage) {
            let offset = (page - 1) * STUDENTS_PER_PAGE;
            const studentPage = {...this.state.studentPage, offset: offset}
            this.setState({studentPage, pendingStudents: true},()=>{
                this.getNewStudents();
            })
        }
    }
    
    
    onStoreChange(storeStateName, state) {
        let additionalState = {};
        if (state.action.id === this.state.actionID) {
            additionalState = {
                actionID: null,
                pending: false,
                receivedStartDate: this.state.appliedStartDate,
                receivedEndDate: this.state.appliedEndDate,
            };
        }
        else if (state.action.id === this.state.studentActionID) {
            additionalState = {
                studentActionID: null,
                pendingStudents: false
            };
        }
		else if (state.action.id === this.state.export_actionID) {
			let channel_data = state.channelCourseNewStudentRangeCSV[this.props.channelId];
            additionalState = {
                export_actionID: null,
                pending_csv: false,
				csv_data:  channel_data.csvData
            };
		}
        

        this.setState({
            [storeStateName]: state,
            ...additionalState
        });
    }
    
    onStartDateChange(date) {
        this.setState({ startDate: date });
    }

    onEndDateChange(date) {
        this.setState({ endDate: date });
    }

    onApplyDateRange() {
        if (this.state.pending || this.state.pendingStudents || this.state.pending_csv ) {
			console.log("data still pending");
			return;
		}

        if (
            this.state.startDate !== this.state.appliedStartDate
            || this.state.endDate !== this.state.appliedEndDate
        ) {
            persistentDateRange.startDate = this.state.startDate;
            persistentDateRange.endDate = this.state.endDate;
            this.getNewStudentCounts();
        }
    }
    
    onCourseRowClick(evt,course_db_id) {
        this.setState({
            selectedCourseRowKey: course_db_id,
            selectedAssignmentRowKey: '',
            selectedStudentRowKey: '',
        });
    }

    onAssignmentRowClick(selectedCourse,evt,assignment_id) {
        const selectedAssignment = selectedCourse ? find(selectedCourse.assignments, { id: assignment_id }) : null;
        let studentPage = null;
        if (selectedAssignment && selectedAssignment.student_count && !selectedAssignment.students) {
            studentPage = {
                assignment_id,
                limit: STUDENTS_PER_PAGE,
                offset: 0
            };
        }
        const studentPageChanged = !isEqual(this.state.studentPage,studentPage);

        this.setState({
            selectedAssignmentRowKey: assignment_id,
            selectedStudentRowKey: '',
            studentPage
        },()=>{
            if (studentPageChanged) {
                this.getNewStudents();
            }
        });
    }
    
    onStudentRowClick(evt,student_id) {
        this.setState({ selectedStudentRowKey: student_id });
    }

	exportCsv() {
        if (this.state.pending || this.state.pendingStudents || this.state.pending_csv ) {
			console.log("data still pending");
			return;
		}
		if ((this.state.receivedStartDate !== this.state.appliedStartDate) ||
			(this.state.receivedEndDate !== this.state.appliedEndDate)) {
			console.log("inconsistent data. page refresh may help.");
			return;
		}
        const export_actionID = uuid.v4();
		const startDate = this.state.receivedStartDate;
		const endDate = this.state.receivedEndDate;

		this.clearOldCsvData(this.props.channelId, this.state.csv_data);
		this.setState({
			export_actionID,
			pending_csv: true,
			csv_data: null,
		},()=>{
			AnalyticsActions.getChannelCourseNewStudentRangeAllPagesCSV(export_actionID, {
				id: this.props.channelId,
				startDate: Moment(startDate),
				endDate: Moment(endDate),
				studentsPerPage: STUDENTS_PER_PAGE,
			});
		});
	}
	
    // call with params rather than relying on props/state data
    // ...since this operations is often called synchronously just prior to a setState call
	clearOldCsvData(channelId, csv_data) {
		if (csv_data) {
			AnalyticsActions.clearChannelCSV(uuid.v4(),{
				id: channelId,
				csv_filename: csv_data.csv_filename
			});
		}
	}
    
    render() {
        const applyNeeded = (this.state.startDate !== this.state.appliedStartDate || this.state.endDate !== this.state.appliedEndDate);        
        const newStudentRange = this.state.analyticsStoreState.channelCourseNewStudentRange[this.props.channelId];
//        if (!newStudentRange && !applyNeeded) {
//            return <LoadingMainContent/>;
//        }
        
        let datePicker = (
            <Row>
                <div className="col-12 col-sm-5 margin-bottom-sm">
                    <label className="label-form margin-right-sm">
                        Start Date
                    </label>
                    <DatePicker className="margin-right-md" 
                        selected={this.state.startDate} 
                        onChange={this.onStartDateChange}
                        // minDate={Moment(currentChannel.created_at)}
                        maxDate={new Date()}
                    />
                </div>
                <div className="col-12 col-sm-5 margin-bottom-sm">
                    <label className="label-form margin-right-sm">
                        End Date
                    </label>
                    <DatePicker
                        className="margin-right-md"
                        selected={this.state.endDate}
                        onChange={this.onEndDateChange}
                        // minDate={Moment(currentChannel.created_at)}
                        maxDate={new Date()}
                    />
                </div>
                <div className="col-12 col-sm-2 text-right">
                    <Button disabled={this.state.pending || !applyNeeded} onClick={this.onApplyDateRange}>apply date range</Button>
                </div>
            </Row>        
        );
        
        if (!newStudentRange) {
            return (
                <div className={this.props.className}>
                    {datePicker}
                    {(applyNeeded) ? 
                    <div className="text-centered margin-top-lg">Select a date range and hit apply.</div> 
                        : 
                    <LoadingWithCancel onCancel={(this.state.actionID && this.state.pending) ? this.cancelPendingStudentCounts : null}/>
                    }
                </div>
            );
        }
        
        
        // const _courseStats = this.state.analyticsStoreState.channelCourseStats[this.props.channelId].courseStats;
        const _channelData = this.state.analyticsStoreState.channelCourseNewStudentRange[this.props.channelId];
        let dateRangeError = false;
        if (_channelData.error) {
            if (_channelData.error.responseText === "Invalid Date Range") {
                dateRangeError = true;
            }
            else {
                return <ErrorBox error={_channelData.error} />
            }
        }

        const _courseStats = _channelData.courseStats;
        // let totalNewStudents = sumBy(_courseStats,'student_count');
        const selectedCourse = find(_courseStats, { id: this.state.selectedCourseRowKey });
        const selectedAssignment = selectedCourse ? find(selectedCourse.assignments, { id: this.state.selectedAssignmentRowKey }) : null
        const _student_rows = selectedAssignment ? (selectedAssignment.students || []) : [];
        //this.state.analyticsStoreState.channelCourseNewStudentRange[this.props.channelId].students;
        
        let pageControls;
        let numPages = 1;
        if (selectedAssignment && selectedAssignment.student_count && _student_rows.length < selectedAssignment.student_count) {
            // we have multiple pages
            let maxPages = Math.ceil(selectedAssignment.student_count / STUDENTS_PER_PAGE);
            numPages = maxPages; // may use in case we add filtering
            let currentPage = selectedAssignment.students_offset ? (1 + Math.floor(selectedAssignment.students_offset / STUDENTS_PER_PAGE)) : 1;

            // show 10 page numbers at a time
            let pageButtons;
            if (maxPages > 1) {
                pageButtons = [];
                const firstPage = Math.max(1, currentPage - 4);
                const lastPage = Math.min(firstPage + 9, numPages);
                const pageSet = Math.ceil(currentPage / 10);
                const prevSetPage = (pageSet - 1) * 10 - 5;
                const nextSetPage = (pageSet + 1) * 10 - 5;
                
                if (firstPage > 1) {
                    pageButtons.push(
                        <button key={1} className="btn btn-primary" onClick={this.requestStudentPage.bind(this,1)}>
                            {'|<'}
                        </button>
                    );
                }
                
                if (prevSetPage > 1) {
                    pageButtons.push(
                        <button key={prevSetPage} className="btn btn-primary" onClick={this.requestStudentPage.bind(this,prevSetPage)}>
                            {'<<'}
                        </button>
                    );
                }
                
                for (var page=firstPage; page <=lastPage; ++page) {
                    if (page === currentPage) {
                        pageButtons.push(
                            <span key={page} className="current-page">{page}</span>
                        );
                    }
                    else {
                        var pageFunc = this.requestStudentPage.bind(this,page);
                        // () => { this.requestStudentPage(page); } <---- doesn't work (uses the value of page after the end of the loop???
                        pageButtons.push(
                            <button key={page} className="btn btn-primary" onClick={pageFunc}>
                                {page}
                            </button>
                        );
                    }
                }
                
                if (nextSetPage < numPages) {
                    pageButtons.push(
                        <button key={nextSetPage} className="btn btn-primary" onClick={this.requestStudentPage.bind(this,nextSetPage)}>
                            {'>>'}
                        </button>
                    );
                }
                
                if (lastPage < numPages) {
                    pageButtons.push(
                        <button key={numPages} className="btn btn-primary" onClick={this.requestStudentPage.bind(this,numPages)}>
                            {'>|'}
                        </button>
                    );
                }
            }

            pageControls = (
                <div className='student-page-controls' style={{position:'relative',zIndex:1}}>
                    {pageButtons}
                </div>
            );
            
        }
        
        const students = _student_rows.map((stu, index) => {
            let name_or_email = stu.display_name;
            const email = stu.third_party_email || stu.email;
            if (email && stu.display_name) {
                name_or_email = email + " <" + stu.display_name + ">"
            }
            else if (!stu.display_name) {
                name_or_email = email;
            }

            if (!name_or_email) {
                name_or_email = (index+1) + "- no name or email available";
            }

            return {
                id: stu.id,
                name_or_email: name_or_email, // one or more of these could be blank.
                join_date: stu.join_date,
                last_access_date: stu.last_access_date,
            };
        });
		
        return (
            <div className={this.props.className}>
            {/*<h1>{this.props.heading}</h1>*/}
                {datePicker}
                {(!!this.state.pending) &&
                    <LoadingWithCancel onCancel={(this.state.actionID && this.state.pending) ? this.cancelPendingStudentCounts : null}/>
                }
                {(dateRangeError) ?
                    <ErrorBox error={_channelData.error} /> 
                    :
                    <div className="margin-top-lg">
                        <hr className="medium hr-color-8" />
						{ this.state.csv_data ? 
						<a className="fr margin-top-md" href={this.state.csv_data.csv_url} download="courses_with_new_students.csv" target="_blank">
							Download Exported CSV
                        </a>
						:						
                        <Button className="fr margin-top-md" onClick={this.exportCsv} disabled={this.state.pending || this.state.pendingStudents || this.state.pending_csv } >
							{ this.state.pending_csv ? 'Exporting...' : 'Export CSV'}
							{ this.state.pending_csv ? <LoadingSpinner/> : null }
                        </Button>
						}
                        <div className="float-clear" />
                        {(!!this.state.receivedStartDate) && 
                            <SortableTableClassic
                                classNameTableContainer="margin-top-lg margin-bottom-lg"
                                classNameTable="font-size-md"
                                title={
                                    'Courses with new Students  from ' + Moment(this.state.receivedStartDate).format('YYYY-MM-DD') + ' to ' + Moment(this.state.receivedEndDate).format('YYYY-MM-DD')
                                }
                                totalName="Total Courses"
                                additionalTotalRowKeys={["student_count"]}
                                rows={_courseStats}
                                uniqueRowKey="id"
                                selectedRowKey={this.state.selectedCourseRowKey}
                                onRowClick={this.onCourseRowClick}
                                defaultSort={{ key: 'create_date', type: 'date', asc: true }}
                                exportButtonName="Export Table"
                                columns={[
                                    /*{
                                        displayName: 'ID',
                                        key: 'id',
                                        type: 'string',
                                        size: 1,
                                        // width: '10%'
                                    },*/
                                    {
                                        displayName: 'Course Name',
                                        key: 'course_name',
                                        type: 'string',
                                        size: 2,
                                        // width: '20%'
                                    },
                                    {
                                        displayName: 'Create Date',
                                        key: 'create_date',
                                        type: 'date',
                                        size: 1,
                                        // width: '10%'
                                    },
                                    {
                                        displayName: 'Last Accessed',
                                        key: 'last_access_date',
                                        type: 'date',
                                        size: 1,
                                        // width: '10%'
                                    },
                                    {
                                        displayName: 'Assignments',
                                        key:'assignment_count',
                                        type: 'int',
                                        size: 1,
                                        // width: '10%'
                                    },
                                    {
                                        displayName: 'New Students',
                                        key: 'student_count',
                                        type: 'int',
                                        size: 1,
                                        // width: '10%'
                                    }
                                ]}
                            />
                        }
                        {(!!selectedCourse) && 
                            <hr className="medium hr-color-8" />
                        }
                        {(!!selectedCourse) &&
                            <SortableTableClassic
                                classNameTableContainer="margin-top-lg margin-bottom-lg"
                                classNameTable="font-size-md"
                                title={
                                    'Assignments with new Students in ' + 
                                    ( selectedCourse.course_name ? selectedCourse.course_name : 'selected course') + 
                                    ' from ' + Moment(this.state.startDate).format('YYYY-MM-DD') + ' to ' + Moment(this.state.endDate).format('YYYY-MM-DD')
                                }
                                totalName="Total Assignments"
                                rows={selectedCourse.assignments}
                                uniqueRowKey="id"
                                selectedRowKey={this.state.selectedAssignmentRowKey}
                                onRowClick={this.onAssignmentRowClick.bind(this,selectedCourse)}
                                defaultSort={{ key: 'name', type: 'string', asc: true }}
                                columns={[
                                    {
                                        displayName: 'Assignment',
                                        key: 'name',
                                        type: 'string',
                                        size: 2,
                                    },
                                    {
                                        displayName: 'Create Date',
                                        key: 'create_date',
                                        type: 'date',
                                        size: 2,
                                    },
                                    {
                                        displayName: 'Activity',
                                        key: 'activity_name',
                                        type: 'string',
                                        size: 2,
                                    },
                                    {
                                        displayName: 'Activity ID',
                                        key: 'nova_act_id',
                                        type: 'string',
                                        size: 3,
                                    },
                                    {
                                        displayName: 'Activity Version',
                                        key: 'activity_version',
                                        type: 'string',
                                        size: 1,
                                    },
                                    {
                                        displayName: 'Template',
                                        key: 'template',
                                        type: 'string',
                                        size: 2,
                                    },
                                    {
                                        displayName: 'New Students',
                                        key: 'student_count',
                                        type: 'int',
                                        size: 1,
                                    }
                                ]}
                            />
                        }
                        {(!!selectedAssignment) &&
                            <hr className="medium hr-color-8" />
                        }
                        
                        { (!!selectedAssignment) ? pageControls : null }
                        
                        { this.state.pendingStudents ? <LoadingSpinner /> : null }

                        
                        {(!!selectedAssignment) &&
                            <SortableTableClassic
                                classNameTableContainer="margin-top-lg margin-bottom-lg"
                                classNameTable="font-size-md"
                                title={
                                    'New Students in ' + 
                                    ( selectedAssignment.name ? selectedAssignment.name : 'selected assignment') + 
                                    ' from ' + Moment(this.state.startDate).format('YYYY-MM-DD') + ' to ' + Moment(this.state.endDate).format('YYYY-MM-DD')
                                }
                                totalName={ (numPages>1) ? 'Page Total' : 'Total' }
                                rows={students}
                                uniqueRowKey="id"
                                selectedRowKey={this.state.selectedStudentRowKey}
                                onRowClick={this.onStudentRowClick}
                                defaultSort={{ key: 'create_date', type: 'date', asc: true }}
                                columns={[
                                    /*{
                                        displayName: 'ID',
                                        key: 'id',
                                        type: 'string',
                                        size: 1,
                                        // width: '10%'
                                    },*/
                                    {
                                        displayName: 'Student',
                                        key: 'name_or_email',
                                        type: 'string',
                                        size: 1,
                                        // width: '10%'
                                    },
                                    {
                                        displayName: 'Join Date',
                                        key: 'join_date',
                                        type: 'date',
                                        size: 1,
                                        // width: '10%'
                                    },
                                    {
                                        displayName: 'Last Active Date',
                                        key: 'last_access_date',
                                        type: 'date',
                                        size: 1,
                                        // width: '10%'
                                    },
                                ]}
                            />
                        }
                    </div>
                }
            </div>
        )
    }
}

CourseStatsView.propTypes = propTypes;
CourseStatsView.defaultProps = defaultProps;

export default CourseStatsView;